<template>
  <div>
    <ol class="breadcrumb m-0 p-0">
      <li class="breadcrumb-item">
        <a @click="toPage('/index')">首页</a>
      </li>
      <li class="breadcrumb-item" v-if="activeBreadcrumb.parentPage && activeBreadcrumb.parentPage!=='index'">
        <a @click="toPage(activeBreadcrumb.parentPush)">{{activeBreadcrumb.parentPage}}</a>
      </li>
      <li class="breadcrumb-item" :class="active==2?'active':''" v-if="activeBreadcrumb.title">
        <a @click="toPage(activeBreadcrumb.puth,active)">{{activeBreadcrumb.title}}</a>
      </li>
      <li v-if="active==1" class="breadcrumb-item active">详情</li>
    </ol>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: [String, Number],
      default: "",
    },
    active: {
      type: Number,
      default: 2, //1：详情//2:列表
    },
  },
  data() {
    return {
      breadcrumbList: [
        {
          id: 9,
          title: "课题通知",
          titleEn: "Subject Notice",
          puth: "/publicList/9",
          parentPage: "课题研究",
          parentPush: "/subjectResearch",
        },
        {
          id: 10,
          title: "科研新闻",
          titleEn: "Research Dynamics",
          puth: "/publicList/10",
          parentPage: "科研动态",
          parentPush: "/researchDynamics",
        },
        {
          id: 11,
          parentPage: "index",
          title: "通知公告",
          titleEn: "Notice",
          puth: "/publicList/11",
        },
        {
          id: 13,
          parentPage: "index",
          title: "先进集体",
          titleEn: "Advanced Collective",
          puth: "/publicList/13",
        },
        {
          id: 14,
          parentPage: "index",
          title: "先进个人",
          titleEn: "Outstanding Person",
          puth: "/publicList/14",
        },
        {
          id: 15,
          parentPage: "index",
          title: "相关下载",
          titleEn: "Downloads",
          puth: "/publicList/15",
        },
        {
          id: 16,
          title: "政策文件",
          titleEn: "Policy Documents",
          puth: "/publicList/16",
          parentPage: "科研动态",
          parentPush: "/researchDynamics",
        },
        {
          id: "projectApplication",
          title: "课题申报",
          titleEn: "Project Application",
          puth: "/subjectResearchList",
          parentPage: "课题研究",
          parentPush: "/subjectResearch",
        },
      ],
      activeBreadcrumb: {},
    };
  },
  watch: {
    id: function () {
      this.getActiveBreadcrumb();
    },
  },
  mounted() {
    this.getActiveBreadcrumb();
  },
  methods: {
    getActiveBreadcrumb() {
      this.breadcrumbList.forEach((item) => {
        if (item.id == this.id) {
          this.activeBreadcrumb = item;
        }
      });
    },
    toPage(url, active) {
      if (active == 2) return;
      this.$router.push(url);
    },
  },
};
</script>

<style>
.breadcrumb-item.active a {
  color: #adb5bd;
}
</style>
